import { languages } from '../../../constants/language.constants';
// Dynamic import that would use correct base href is not working with esbuild and Angular 16.
// That is why we are importing them statically. There is a JIRA ticket FC-111 to fix this issue.
// See issue: https://github.com/angular/angular-cli/issues/25574
import de from '../../../../assets/countries/de.json';
import en from '../../../../assets/countries/en.json';
import es from '../../../../assets/countries/es.json';
import it from '../../../../assets/countries/it.json';
import pt from '../../../../assets/countries/pt.json';

export const countriesByLanguage: CountryByLanguage = {
  [languages.de]: de.countries,
  [languages.en]: en.countries,
  [languages.es]: es.countries,
  [languages.it]: it.countries,
  [languages.pt]: pt.countries
};

export type CountryDetails = { name: string; nationality?: string; value: string };

export type Country = { [key: string]: Omit<CountryDetails, 'value'> };

export type CountryByLanguage = { [key in languages]?: Country };
